import memoize from "fast-memoize";
import React from "react";
import { Field } from "redux-form";
import { createTextMask } from "redux-form-input-masks";

import buildFormField from "./buildFormField";
import PhoneInput from "./PhoneInput";

const FormField = buildFormField(PhoneInput, (input, meta, rest) => {
  return {
    ...input,
    autoComplete: "off",
    ...rest,
    invalid: `${meta.touched && (meta.invalid || rest.invalid)}`,
  };
});

let id = 0;
function memoizedId(x) {
  if (!x.__memoizedId) x.__memoizedId = ++id;
  return { __memoizedId: x.__memoizedId };
}

// this needs to be memoizable!
const buildValidator = memoize(
  (required, other) => {
    return [
      (value) => {
        if (required && !value) {
          return "required";
        }
        if (value.length < 11) {
          return "minSize";
        }
        return undefined;
      },
    ].concat(other || []);
  },
  {
    serializer: (args) => {
      const argumentsWithFuncIds = Array.from(args).map((x) => {
        if (typeof x === "function") return memoizedId(x);
        return x;
      });
      return JSON.stringify(argumentsWithFuncIds);
    },
  }
);

const phoneNumberMask = createTextMask({
  pattern: "(99) 999999999",
  guide: false,
  allowEmpty: true,
});

export default function PhoneField(props) {
  const { required, validate } = props;

  return (
    <Field
      {...props}
      {...phoneNumberMask}
      component={FormField}
      placeholder="(99) 999999999"
      validate={buildValidator(required, validate)}
    />
  );
}
